.toggle {
  display: flex;
  align-items: center;
  align-self: flex-start;
  gap: var(--dixa-size-spacer-200);
  padding: 0;
  border: none;
  background-color: transparent;
  cursor: pointer;

  &:focus-visible {
    outline: var(--dixa-size-border-200) solid var(--dixa-color-purple-300);
    outline-offset: var(--dixa-size-border-100);
  }
}

// Inside the Collapsible, so the gaps only show when expanded.
.body {
  margin-block: var(--dixa-size-spacer-250);
  padding-left: var(--dixa-size-spacer-250);
  border-left: var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);
}
